<template>
  <div>
    <SimpleNav />
    <div v-cloak class="row">
      <div id="hidden-div" class="col m3"></div>
      <div id="bcrumbs" class="col s12 m3 crumbs">
        <nav id="breadcrumbs-nav">
          <div class>
            <div class="col s12">
              <a href="#!" class="breadcrumb"></a>
              <a href="#!" class="breadcrumb" @click="$router.go(-1)">Class Projects</a>
            </div>
          </div>
        </nav>
      </div>
      <div id="name-banner" class="col s12 m6">
        <h1>{{projects[id-1].name}}</h1>
      </div>
      <div class="col s3"></div>
    </div>
    <div class="container col s12">
      <div class="row">
        <div class="col s12 m6">
          <h5>Project Date / Status:</h5>
          {{projects[id-1].date}}
        </div>
        <div class="col s12 m6">
          <h5>Tech:</h5>
          {{projects[id-1].tech}}
        </div>
      </div>
      <div class="row">
        <div class="col s12">
          <h5>Project Description:</h5>
          {{projects[id-1].desc}}
        </div>
      </div>
      <div class="row">
        <div class="col s12">
          <h5>Project Role:</h5>
          {{projects[id-1].role}}
        </div>
      </div>
      <hr />
    </div>
    <h1>Media</h1>
    <div v-cloak class="container">
      <div v-if="id==3">
        <div class="container vid">
          <video class="responsive-video" controls>
            <source src="/capstone.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
      <div v-if="id !=3" class="slider">
        <ul v-if="id == 1" class="slides transparent">
          <li v-for="(image, index) in imageSources[0].bs" :key="index">
            <img :src="image" class="slide-image" />
          </li>
        </ul>
        <ul v-if="id == 2" class="slides transparent">
          <li v-for="(image, index) in imageSources[0].nc" :key="index">
            <img :src="image" class="slide-image" />
          </li>
        </ul>
        <ul v-if="id == 4" class="slides transparent">
          <li v-for="(image, index) in imageSources[0].u" :key="index">
            <img :src="image" class="slide-image" />
          </li>
        </ul>
        <ul v-if="id == 5" class="slides transparent">
          <li v-for="(image, index) in imageSources[0].n" :key="index">
            <img :src="image" class="slide-image" />
          </li>
        </ul>
      </div>
    </div>

    <br />
    <Footer />
  </div>
</template>

<script>
import SimpleNav from "@/components/SimpleNav.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "ProjectPartialPage",
  components: {
    SimpleNav,
    Footer
  },
  props: {
    id: { type: [String, Number] }
  },
  data() {
    return {
      isSmall: false,
      directives: {
        visible(el, bind) {
          var bc = document.getElementById("bcrumbs");
          var bcPlaceholder = document.getElementById('hidden-div');
          bcPlaceholder.style.visibility = bc.style.display == 'none'  ? "visible" : "hidden";
        }
      },
      projects: [
        {
          id: 1,
          name: "Battleship+",
          tech: "C# WPF",
          isCompleted: true,
          desc:
            "Improved an existing game of Battleship from GitHub and improved its UI/UX, broken game logic, and messy code. In addition, we also added new game modes on top of the existing ones.",
          date: "Summer 2018 / Completed",
          role:
            "My role on this group project (group of 4) was to improve the UI and logic for the ship placement GUI page. Previously " +
            "the ship placement logic was broken and allowed players to place their ships on top of other ships. That was the main issue I fixed as well as updating the ships from being gray blocks to actual png images."
        },
        {
          id: 2,
          name: "Innovation Center Website",
          tech: "C# ASP.NET MVC, JavaScript, SQL",
          isCompleted: true,
          desc:
            "A website intended that serves as a repository for Neumont Innovation Lab student projects, including administrative privileges for the Director of the Innovation Center.",
          date: "Summer 2018 / Completed",
          role:
            "My role on this group project (group of 3) was to add content to the Projects page for the main site. My main contribution was to " +
            "take the list of projects from a database and display them on the Projects page of the site. In addition, I was also responsible for creating the form pages for both editing and adding new projects."
        },
        {
          id: 3,
          name: "musiccentral",
          tech:
            "VueJS, JavaScript, Firebase DB, Spotify Web Playback API, Last.fm API",
          isCompleted: false,
          desc:
            "A website that aimed to bring together the best music application's features/music" +
            " and centralize them into one site. Features including playlist making, favorites, top five, and audio playback through a Spotify connection",
          date: "Fall 2018 / WIP",
          role:
            "As a solo project I was in charge of all aspects of this 10 week project."
        },
        {
          id: 4,
          name: "Random User API",
          tech: "Angular JS, Node, Express",
          isCompleted: true,
          desc:
            "Built an api that could return a number of randomly generated users with data. Users also had partial views that held more data about that specific user. Users could also be filtered through some options such as gender or age.",
          date: "Summer 2018 / Completed",
          role:
            "As a solo class project I was in charge of all aspects of the project."
        },
        {
          id: 5,
          name: "News Article Website",
          tech: "React JS",
          isCompleted: true,
          desc:
            "Website that listed 10 of my personal favorite news outlets. Each outlet provided a number of the latest articles upon the click of a button",
          date: "Summer 2018 / Completed",
          role:
            "As a solo class project I was in charge of all aspects of the project."
        }
      ],
      imageSources: [
        {
          bs: [
            "/images/BS7.jpg",
            "/images/BS8.jpg",
            "/images/BS9.jpg",
            "/images/BS10.jpg",
            "/images/BS11.jpg",
            "/images/BS1.jpg",
            "/images/BS2.jpg",
            "/images/BS3.jpg",
            "/images/BS4.jpg",
            "/images/BS5.jpg",
            "/images/BS6.jpg"
          ],
          nc: [
            "/images/NC1.jpg",
            "/images/NC2.jpg",
            "/images/NC3.jpg",
            "/images/NC4.jpg",
            "/images/NC5.jpg",
            "/images/NC6.jpg",
            "/images/NC7.jpg"
          ],
          u: [
            "/images/U1.jpg",
            "/images/U2.jpg",
            "/images/U3.jpg",
            "/images/U4.jpg"
          ],
          n: [
            "/images/N1.jpg",
            "/images/N2.jpg",
            "/images/N3.jpg",
            "/images/N4.jpg"
          ]
        }
      ]
    };
  },
  methods: {},
  mounted() {
    // document.addEventListener('DOMContentLoaded', function() {
    var elems = document.querySelectorAll(".slider");
    var instances = M.Slider.init(elems, {});
    // });
    var ban = document.getElementById("name-banner").className;
    console.log(ban);
  },
  created() {
    // var bc = document.getElementById('bcrumbs');
    // var bcPlaceholder = document.getElementById('hidden-div');
    // if(bc.style.display == "none"){
    //   bc.style.display == "visible"
    // }
  }
};
</script>

<style>
.slider .slides li img {
  background-size: contain;
  background-repeat: no-repeat;
}

h5 {
  color: #a60512;
}
#hidden-div{
  display: none;
}
@media screen and (max-width: 750px) {
  .crumbs {
    display: none;
  }
  #hidden-div{
  display: block;
}
}

.slider .indicators .indicator-item.active {
  background: #a60512;
}
.crumbs {
  margin-top: 50px;
}
#breadcrumbs-nav {
  background-color: transparent;
  -webkit-box-shadow: none;
}
#breadcrumbs-nav a {
  color: #000;
}
#breadcrumbs-nav a::before {
  color: #000;
}
.slide-image {
  /* border: 2px solid black; */
  /* box-shadow: 10px 10px 10px 10px #000; */
}
</style>
